import { NgTemplateOutlet } from '@angular/common';
import { AfterContentInit, Component, ElementRef, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { PRODUCT_PLACEHOLDER } from 'src/app/app.settings';
import { Banner, BannerType } from 'src/app/models';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { TextButtonComponent } from '../../button';
import { ContentImagePipe } from '../../../pipes/cms-image.pipe';

@Component({
  selector: 'app-split-banner',
  templateUrl: './split-banner.component.html',
  styleUrls: ['./split-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TextButtonComponent, NgTemplateOutlet, ContentImagePipe],
})
export class SplitBannerComponent implements OnInit, AfterContentInit {
  private themeService = inject(ThemeService);
  private elRef = inject(ElementRef);

  placeholder = PRODUCT_PLACEHOLDER;

  @Input() content: Banner[];
  @Input() isMobile: boolean;
  leftBanner: Banner;
  rightBanner: Banner;

  ngOnInit() {
    this.leftBanner = this.content.find((banner) => banner?.type === BannerType.Left);
    this.rightBanner = this.content.find((banner) => banner?.type === BannerType.Right);
  }

  ngAfterContentInit() {
    this.themeService.subscribeComponent(this.elRef);
  }
}
